import React, { useState } from "react";
import {
  AppBar, Toolbar, Stack, Button, Popover, List, ListItem, ListItemIcon, ListItemText, Typography
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LanguageIcon from "@mui/icons-material/Language";
import ApiIcon from "@mui/icons-material/Api";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import SchoolIcon from "@mui/icons-material/School";
import ForumIcon from "@mui/icons-material/Forum";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import GavelIcon from "@mui/icons-material/Gavel";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { Link as RouterLink } from "react-router-dom";

export default function MainMenu() {
  const [productoAnchor, setProductoAnchor] = useState(null);
  const [solucionesAnchor, setSolucionesAnchor] = useState(null);
  const [recursosAnchor, setRecursosAnchor] = useState(null);

  const handleProductoClick = (event) => setProductoAnchor(event.currentTarget);
  const handleProductoClose = () => setProductoAnchor(null);

  const handleSolucionesClick = (event) => setSolucionesAnchor(event.currentTarget);
  const handleSolucionesClose = () => setSolucionesAnchor(null);

  const handleRecursosClick = (event) => setRecursosAnchor(event.currentTarget);
  const handleRecursosClose = () => setRecursosAnchor(null);

  return (
    <AppBar position="static" color="transparent" elevation={0} sx={{ zIndex: 2 }}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography variant="h5" fontWeight={700} color="#38bdf8" letterSpacing={2}>
          NARA
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          {/* Menú Producto */}
          <Button
            color="inherit"
            sx={{ fontWeight: 500, color: "#cbd5e1" }}
            aria-controls={productoAnchor ? "producto-popover" : undefined}
            aria-haspopup="true"
            onClick={handleProductoClick}
          >
            Producto
          </Button>
          <Popover
            id="producto-popover"
            open={Boolean(productoAnchor)}
            anchorEl={productoAnchor}
            onClose={handleProductoClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 270,
                background: "rgba(30,41,59,0.98)",
                borderRadius: 3,
                boxShadow: "0 8px 32px 0 rgba(56,189,248,0.13)",
                color: "#cbd5e1",
                border: "1px solid #334155",
              },
            }}
          >
            <List>
              <ListItem button component={RouterLink} to="/whatsapp-chatbot" onClick={handleProductoClose}>
                <ListItemIcon>
                  <WhatsAppIcon sx={{ color: "#25D366" }} />
                </ListItemIcon>
                <ListItemText
                  primary="WhatsApp Chatbot"
                  secondary="Automatiza conversaciones en WhatsApp Business"
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem button component={RouterLink} to="/website-chatbot" onClick={handleProductoClose}>
                <ListItemIcon>
                  <LanguageIcon sx={{ color: "#6366f1" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Website Chatbot"
                  secondary="Chatbots inteligentes para tu sitio web"
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem button>
                <ListItemIcon>
                  <ApiIcon sx={{ color: "#0ea5e9" }} />
                </ListItemIcon>
                <ListItemText
                  primary="API & SDK"
                  secondary="Integra NARA en tus propios sistemas"
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
            </List>
          </Popover>
          {/* Menú Soluciones */}
          <Button
            color="inherit"
            sx={{ fontWeight: 500, color: "#cbd5e1" }}
            aria-controls={solucionesAnchor ? "soluciones-popover" : undefined}
            aria-haspopup="true"
            onClick={handleSolucionesClick}
          >
            Soluciones
          </Button>
          <Popover
            id="soluciones-popover"
            open={Boolean(solucionesAnchor)}
            anchorEl={solucionesAnchor}
            onClose={handleSolucionesClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 320,
                background: "rgba(30,41,59,0.98)",
                borderRadius: 3,
                boxShadow: "0 8px 32px 0 rgba(56,189,248,0.13)",
                color: "#cbd5e1",
                border: "1px solid #334155",
              },
            }}
          >
            <List>
              <ListItem>
                <ListItemIcon>
                  <MedicalServicesIcon sx={{ color: "#38bdf8" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Atención médica"
                  secondary="Automatiza la gestión de citas, recordatorios y consultas médicas."
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <SupportAgentIcon sx={{ color: "#6366f1" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Servicio de soporte"
                  secondary="Responde tickets y consultas frecuentes de manera automática."
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <PeopleAltIcon sx={{ color: "#0ea5e9" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Atención al cliente"
                  secondary="Mejora la experiencia de tus clientes con respuestas inmediatas."
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <GavelIcon sx={{ color: "#fbbf24" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Bufetes de abogados"
                  secondary="Automatiza consultas legales y seguimiento de casos."
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <EngineeringIcon sx={{ color: "#34d399" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Oficina de ingenieros"
                  secondary="Gestiona proyectos, consultas técnicas y soporte de ingeniería."
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
            </List>
          </Popover>
          {/* Menú Recursos */}
          <Button
            color="inherit"
            sx={{ fontWeight: 500, color: "#cbd5e1" }}
            aria-controls={recursosAnchor ? "recursos-popover" : undefined}
            aria-haspopup="true"
            onClick={handleRecursosClick}
          >
            Recursos
          </Button>
          <Popover
            id="recursos-popover"
            open={Boolean(recursosAnchor)}
            anchorEl={recursosAnchor}
            onClose={handleRecursosClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 270,
                background: "rgba(30,41,59,0.98)",
                borderRadius: 3,
                boxShadow: "0 8px 32px 0 rgba(56,189,248,0.13)",
                color: "#cbd5e1",
                border: "1px solid #334155",
              },
            }}
          >
            <List>
              <ListItem button>
                <ListItemIcon>
                  <ViewModuleIcon sx={{ color: "#6366f1" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Plantillas de Chatbot"
                  secondary="Modelos listos para usar en tu negocio"
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem button>
                <ListItemIcon>
                  <SchoolIcon sx={{ color: "#38bdf8" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Tutoriales"
                  secondary="Aprende a crear y optimizar tus chatbots"
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
              <ListItem button component="a" href="https://discord.com/" target="_blank" rel="noopener">
                <ListItemIcon>
                  <ForumIcon sx={{ color: "#5865F2" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Comunidad en Discord"
                  secondary="Únete y comparte con otros usuarios"
                  primaryTypographyProps={{ fontWeight: 700, color: "#fff" }}
                  secondaryTypographyProps={{ color: "#94a3b8" }}
                />
              </ListItem>
            </List>
          </Popover>
          {/* Botón Pruebe NARA gratis */}
          <Button
            variant="contained"
            component={RouterLink}
            to="/constructor"
            sx={{
              ml: 2,
              background: "linear-gradient(90deg, #6366f1 0%, #0ea5e9 100%)",
              fontWeight: 700,
              color: "#fff",
              borderRadius: 2,
              px: 3,
              py: 1,
              boxShadow: "0 2px 8px rgba(99,102,241,0.12)",
              textTransform: "none",
              "&:hover": { background: "linear-gradient(90deg, #0ea5e9 0%, #6366f1 100%)" },
            }}
          >
            Pruebe NARA gratis
          </Button>
          <Button
            color="inherit"
            sx={{ fontWeight: 500, color: "#cbd5e1" }}
            component={RouterLink}
            to="/constructor"
          >
            Login
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}